import ProtectedRoute from "@/shared/components/auth/ProtectedRoute";

// Reseller Pages
import ResellerDashboard from "@/shared/pages/ResellerDashboard";
import ResellerTransactions from "@/shared/pages/ResellerTransactions";
import ResellerMerchants from "@/shared/pages/ResellerMerchants";
import ResellerProviders from "@/shared/pages/ResellerProviders";
import ResellerSettings from "@/shared/pages/ResellerSettings";
import ResellerDeposits from "@/shared/pages/ResellerDeposits";
import ResellerWithdrawals from "@/shared/pages/ResellerWithdrawals";
import ResellerRouting from "@/shared/pages/ResellerRouting";
import ResellerWebhooks from "@/shared/pages/ResellerWebhooks";
import ResellerSettlements from "@/shared/pages/ResellerSettlements";

// Merchant Pages
import MerchantDashboard from "@/shared/pages/MerchantDashboard";
import MerchantTransactions from "@/shared/pages/MerchantTransactions";
import MerchantDeposit from "@/shared/pages/MerchantDeposit";
import MerchantWithdrawals from "@/shared/pages/MerchantWithdrawals";
import MerchantSettings from "@/shared/pages/MerchantSettings";
import MerchantProviders from "@/shared/pages/MerchantProviders";
import MerchantRouting from "@/shared/pages/MerchantRouting";
import MerchantWebhooks from "@/shared/pages/MerchantWebhooks";
import MerchantSettlements from "@/shared/pages/MerchantSettlements";
import Notifications from "@/shared/pages/Notifications";
import MerchantLayout from "@/shared/components/merchant/MerchantLayout";
import ResellerLayout from "@/shared/components/reseller/ResellerLayout";

// Login Pages
import ResellerLogin from "@/shared/pages/ResellerLogin";
import MerchantLogin from "@/shared/pages/MerchantLogin";
import StaffLogin from "@/shared/pages/StaffLogin";

// Portal-specific unified login
import PortalLogin from "./PortalLogin";

import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { auth } from "@/shared/api/graphqlClient";

function PortalAppContent() {
  const location = useLocation();

  // Check if current route is a login page
  const loginPaths = [
    '/login', '/ResellerLogin', '/MerchantLogin',
    '/staff-login', '/StaffLogin'
  ];
  const isLoginPage = loginPaths.includes(location.pathname);

  // If it's a login page, render without Layout (these pages have their own layout)
  if (isLoginPage) {
    return (
      <Routes>
        <Route path="/login" element={<PortalLogin />} />
        <Route path="/ResellerLogin" element={<ResellerLogin />} />
        <Route path="/MerchantLogin" element={<MerchantLogin />} />
        <Route path="/staff-login" element={<StaffLogin />} />
        <Route path="/StaffLogin" element={<StaffLogin />} />
      </Routes>
    );
  }

  // Otherwise, render the appropriate routes (these pages have their own layouts)
  return (
    <Routes>
      {/* Default route - redirect based on user role */}
      <Route path="/" element={<RoleBasedRedirect />} />

      {/* Reseller Routes - Protected */}
      <Route path="/ResellerDashboard" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerDashboard /></ProtectedRoute>} />
      <Route path="/reseller/dashboard" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerDashboard /></ProtectedRoute>} />
      <Route path="/ResellerTransactions" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerTransactions /></ProtectedRoute>} />
      <Route path="/reseller/transactions" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerTransactions /></ProtectedRoute>} />
      <Route path="/ResellerMerchants" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerMerchants /></ProtectedRoute>} />
      <Route path="/reseller/merchants" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerMerchants /></ProtectedRoute>} />
      <Route path="/ResellerProviders" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerProviders /></ProtectedRoute>} />
      <Route path="/reseller/providers" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerProviders /></ProtectedRoute>} />
      <Route path="/ResellerSettings" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerSettings /></ProtectedRoute>} />
      <Route path="/reseller/settings" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerSettings /></ProtectedRoute>} />
      <Route path="/ResellerDeposits" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerDeposits /></ProtectedRoute>} />
      <Route path="/reseller/deposits" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerDeposits /></ProtectedRoute>} />
      <Route path="/ResellerWithdrawals" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerWithdrawals /></ProtectedRoute>} />
      <Route path="/reseller/withdrawals" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerWithdrawals /></ProtectedRoute>} />
      <Route path="/ResellerRouting" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerRouting /></ProtectedRoute>} />
      <Route path="/reseller/routing" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerRouting /></ProtectedRoute>} />
      <Route path="/ResellerWebhooks" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerWebhooks /></ProtectedRoute>} />
      <Route path="/reseller/webhooks" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerWebhooks /></ProtectedRoute>} />
      <Route path="/ResellerSettlements" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerSettlements /></ProtectedRoute>} />
      <Route path="/reseller/settlements" element={<ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}><ResellerSettlements /></ProtectedRoute>} />
      <Route path="/reseller/notifications" element={<PortalNotificationsRoute />} />
      <Route path="/ResellerNotifications" element={<PortalNotificationsRoute />} />

      {/* Merchant Routes - Protected */}
      <Route path="/MerchantDashboard" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantDashboard /></ProtectedRoute>} />
      <Route path="/merchant/dashboard" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantDashboard /></ProtectedRoute>} />
      <Route path="/MerchantTransactions" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantTransactions /></ProtectedRoute>} />
      <Route path="/merchant/transactions" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantTransactions /></ProtectedRoute>} />
      <Route path="/MerchantDeposit" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantDeposit /></ProtectedRoute>} />
      <Route path="/merchant/deposits" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantDeposit /></ProtectedRoute>} />
      <Route path="/MerchantWithdrawals" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantWithdrawals /></ProtectedRoute>} />
      <Route path="/merchant/withdrawals" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantWithdrawals /></ProtectedRoute>} />
      <Route path="/MerchantSettings" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantSettings /></ProtectedRoute>} />
      <Route path="/merchant/settings" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantSettings /></ProtectedRoute>} />
      <Route path="/MerchantProviders" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantProviders /></ProtectedRoute>} />
      <Route path="/merchant/providers" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantProviders /></ProtectedRoute>} />
      <Route path="/MerchantRouting" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantRouting /></ProtectedRoute>} />
      <Route path="/merchant/routing" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantRouting /></ProtectedRoute>} />
      <Route path="/MerchantWebhooks" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantWebhooks /></ProtectedRoute>} />
      <Route path="/merchant/webhooks" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantWebhooks /></ProtectedRoute>} />
      <Route path="/MerchantSettlements" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantSettlements /></ProtectedRoute>} />
      <Route path="/merchant/settlements" element={<ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}><MerchantSettlements /></ProtectedRoute>} />
      <Route path="/merchant/notifications" element={<PortalNotificationsRoute />} />
      <Route path="/MerchantNotifications" element={<PortalNotificationsRoute />} />
      <Route path="/Notifications" element={<PortalNotificationsRoute />} />
      <Route path="/notifications" element={<PortalNotificationsRoute />} />

      {/* Catch-all redirect to login */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}

// Component to redirect based on user role
function RoleBasedRedirect() {
  const userRole = auth.getUserRole()?.toUpperCase();

  if (!userRole) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to appropriate dashboard based on role
  // Note: ENGINE and STAFF_ENGINE should use engine.1401.com
  const dashboardMap = {
    'RESELLER': '/ResellerDashboard',
    'STAFF_RESELLER': '/ResellerDashboard',
    'MERCHANT': '/MerchantDashboard',
    'STAFF_MERCHANT': '/MerchantDashboard',
  };

  const targetDashboard = dashboardMap[userRole];

  if (targetDashboard) {
    return <Navigate to={targetDashboard} replace />;
  }

  // If ENGINE role, redirect to engine domain
  // if (userRole === 'ENGINE' || userRole === 'STAFF_ENGINE') {
  //   window.location.href = 'https://engine.1401.com';
  //   return null;
  // }

  // Default to login if role not recognized
  return <Navigate to="/login" replace />;
}

import { LanguageProvider } from "@/shared/components/shared/LanguageContext";

export default function PortalApp() {
  return (
    <Router>
      <LanguageProvider>
        <PortalAppContent />
      </LanguageProvider>
    </Router>
  );
}

function PortalNotificationsRoute() {
  const userRole = auth.getUserRole()?.toUpperCase();

  if (userRole === 'MERCHANT' || userRole === 'STAFF_MERCHANT') {
    return (
      <ProtectedRoute allowedRoles={['MERCHANT', 'STAFF_MERCHANT']}>
        <MerchantLayout currentPage="Notifications">
          <Notifications />
        </MerchantLayout>
      </ProtectedRoute>
    );
  }

  if (userRole === 'RESELLER' || userRole === 'STAFF_RESELLER') {
    return (
      <ProtectedRoute allowedRoles={['RESELLER', 'STAFF_RESELLER']}>
        <ResellerLayout currentPage="Notifications">
          <Notifications />
        </ResellerLayout>
      </ProtectedRoute>
    );
  }

  return <Navigate to="/login" replace />;
}

